<div class="header">
    <ui-help-menu
        (showIntercom)="onIntercom()"
        (showIntercomNews)="onIntercomNews()"
        (showKeyboardShortcuts)="onKeyboardShortcuts()"
    />
</div>
